import type {
  AlertStatus,
  ChakraTheme,
  SystemStyleObjectRecord,
  ThemeComponentFunction,
} from '@chakra-ui/react'

const STATUS_TO_COLORS: Record<AlertStatus, { backgroundColor: string; iconColor: string }> = {
  info: {
    backgroundColor: 'bg.info',
    iconColor: 'fg.info',
  },
  error: {
    backgroundColor: 'bg.error',
    iconColor: 'fg.error',
  },
  warning: {
    backgroundColor: 'bg.warning',
    iconColor: 'fg.warning',
  },
  success: {
    backgroundColor: 'bg.success',
    iconColor: 'fg.success',
  },
  // TODO: Double check this with Rennie. Added during upgrade to Chakra v2
  loading: {
    backgroundColor: 'bg.info',
    iconColor: 'fg.info',
  },
}

const shwVariant = ({ status }: { status?: string }): Record<string, unknown> => {
  if (status == null || !(status in STATUS_TO_COLORS)) {
    return {}
  }

  const { backgroundColor, iconColor } = STATUS_TO_COLORS[status as AlertStatus]

  return {
    container: {
      backgroundColor,
    },
    icon: {
      color: iconColor,
    },
  }
}

export default {
  variants: {
    shw: shwVariant as unknown as ThemeComponentFunction<SystemStyleObjectRecord, ChakraTheme>,
  },
  defaultProps: {
    variant: 'shw',
  },
}
